const _jsxFileName = "C:\\Users\\sz\\Code\\projects\\wehn-checklist\\src\\js\\forms\\components\\TextInput.js";import React, { } from "react";

import { Form, Input, Typography } from "antd";
import "antd/dist/antd.css";


const { Text } = Typography;
const { TextArea } = Input;

function TextInput(props) {
  let style = {};
  if (props.elementStyle) {
    style = props.elementStyle;
  }
  let state = props.Data;
  let options = state.options || {};
  let rules = [];
  if (state["v_required"]) {
    rules.push({
      required: state["v_required"].value,
      message: state["v_required"].err,
    });
  }
  if (options.validation) {
    rules.push(({ getFieldValue }) => ({
      validator(rule, value) {
        let re = new RegExp(options.validation.expression);
        console.log(re, re.test(value), value);
        if (!re.test(value)) return Promise.reject(options.validation.err);
        return Promise.resolve();
      },
    }));
  }
  let inputelement = React.createElement(Input, { style: style, placeholder: state.hint, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} );
  if (state.options.area) {
    inputelement = React.createElement(TextArea, { rows: 4, style: style, placeholder: state.hint, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} );
  }

  return (
    React.createElement(Form.Item, { name: state.key, label: state.title, rules: rules, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
      , inputelement
    )
  );
}
export default TextInput;
